//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import collectionNamingModalTemplate from '@legacy-components/content/collection-naming-modal.html';

(function() {
  angular.module('curalate').component('collectionNamingModal', {
    bindings: {
      modalInstance: '<',
      clickOrigin: '@',
    },
    template: collectionNamingModalTemplate,
    controller: [
      '$timeout',
      'TrackingService',
      function(
        $timeout,
        TrackingService,
      ) {
        const self = this;

        self.cancelClicked = function() {
          self.modalInstance.dismiss('cancel');
        };

        self.createClicked = function() {
          if (self.collectionName) {
            self.modalInstance.close(self.collectionName);
            TrackingService.recordEvent(TrackingService.CATEGORY_LIBRARY, TrackingService.ACTION_COLLECTIONS_CREATE_COLLECTION, self.clickOrigin);
          }
        };

        self.$onInit = function() {
          $timeout(() => {
            angular.element('#collection-name-input').focus();
          });
        };
      },
    ],
  });
})();
